import Link from "@src/app/components/Link";
import { useRouteResponse } from "@src/app/hooks/useRouteResponse";

export default function ArticleAttachments() {
  const route = useRouteResponse("articlePage");

  const attachments = route.article?.attachments || [];

  if (!attachments.length) {
    return null;
  }

  return (
    <div className="mb-4">
      <p className="font-bold text-primary">Attachments:</p>
      {attachments.map((item, index) => {
        return (
          <div key={index}>
            <Link
              className="text-link-primary transition-all hover:text-link-primary-hover"
              to={item.url || ""}
              target="_blank"
              download={item.title}
              rel="noreferrer"
            >
              {item.title}
            </Link>
          </div>
        );
      })}
    </div>
  );
}
